<template>
  <div>

    <div class="position-relative z-index-2">
      <!-- Content -->

      <div class="align-items-md-center space-1 bg-primary text-center ">
        <div class="w-lg-65 mx-lg-auto">
          <!-- Info -->
          <div class="mt-5 mb-7 ">
            <h1 class="display-4 text-white mb-3">Journées portes ouvertes</h1>
            <p class="lead text-white">Partagez vos plans, avec la communauté éducative.</p>
          </div>
          <!-- End Info -->


          <!-- Form -->
          <form class="js-validate mx-lg-auto">
            <div class="card mb-2">
              <!-- Title Section -->
              <div class="bg-light">

                <div style="min-width: 80%;">
                  <select   @change="onChange($event)"  class="form-control" v-model="selected">
                    <option   >---liste des academies---</option>
                    <option v-for="academie in academies" v-bind:value="academie.value" >
                      {{ academie.text }}
                    </option>
                  </select>
                </div>



              </div>
            </div>

<!--            <div class="d-none d-flex row justify-content-end mr-0">-->
<!--              <div class=" ml-3">-->
<!--                <div class="dropdown">-->
<!--                  <button class="btn btn-white dropdown-toggle border-primary" type="button" id="dropdownFields" data-toggle="dropdown">-->
<!--                    Domaines d'étude-->
<!--                  </button>-->
<!--                  <div class="dropdown-menu mt-0" aria-labelledby="dropdownFields">-->
<!--                                <span class="dropdown-item" onclick="event.stopPropagation()">-->
<!--                                    <input type="checkbox" class="pt-1" id="field1">-->
<!--                                    <label class="mb-0" for="customCheck1">Lycée</label>-->
<!--                                </span>-->
<!--                    <span class="dropdown-item" onclick="event.stopPropagation()">-->
<!--                                    <input type="checkbox" class="pt-1" id="field2">-->
<!--                                    <label class="mb-0" for="customCheck2">CFA</label>-->
<!--                                </span>-->
<!--                    <span class="dropdown-item" onclick="event.stopPropagation()">-->
<!--                                    <input type="checkbox" class="pt-1" id="field3">-->
<!--                                    <label class="mb-0" for="customCheck3">Université</label>-->
<!--                                </span>-->
<!--                    <span class="dropdown-item" onclick="event.stopPropagation()">-->
<!--                                    <input type="checkbox" class="pt-1" id="field4">-->
<!--                                    <label class="mb-0" for="customCheck4">Ecoles privées</label>-->
<!--                                </span>-->
<!--                  </div>-->
<!--                </div>-->
<!--                <div class="dropdown">-->
<!--                  <button class="btn btn-white dropdown-toggle border-primary" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">-->
<!--                    Niveaux d'étude-->
<!--                  </button>-->
<!--                  <div class="dropdown-menu mt-0" aria-labelledby="dropdownMenuButton">-->
<!--                            <span class="dropdown-item" onclick="event.stopPropagation()">-->
<!--                                <input type="checkbox" class="pt-1" id="customCheck1">-->
<!--                                <label class="mb-0" for="customCheck1">Lycée</label>-->
<!--                            </span>-->
<!--                    <span class="dropdown-item" onclick="event.stopPropagation()">-->
<!--                                <input type="checkbox" class="pt-1" id="customCheck2">-->
<!--                                <label class="mb-0" for="customCheck2">CFA</label>-->
<!--                            </span>-->
<!--                    <span class="dropdown-item" onclick="event.stopPropagation()">-->
<!--                                <input type="checkbox" class="pt-1" id="customCheck3">-->
<!--                                <label class="mb-0" for="customCheck3">Université</label>-->
<!--                            </span>-->
<!--                    <span class="dropdown-item" onclick="event.stopPropagation()">-->
<!--                                <input type="checkbox" class="pt-1" id="customCheck4">-->
<!--                                <label class="mb-0" for="customCheck4">Ecoles privées</label>-->
<!--                            </span>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--              <button type="button" class="btn btn-success">Partager votre Journée Portes Ouvertes</button>-->
<!--            </div>-->
          </form>
          <!-- End Form -->
        </div>
      </div>

      <!-- End Content -->
    </div>

    <div class="d-lg-none position-absolute top-0 right-0 bottom-0 left-0 bg-img-hero" style="background-image: url(/themes/template/img/1920x1080/img2.jpg);"></div>

    <div class="container-fluid space-1">
      <div class="row">
        <div class="col-12 col-md-7 ">
          <div class="pt-md-2 space-bottom-2 " >
            <l-map
                :center="center"
                :zoom="zoom"
                class="map"
                ref="map"
                style="height: 500px"
                @click="handleMapClick"
                @update:center="centerUpdated"
                @update:zoom="zoomUpdated"
            >

              <l-control-layers  position="topright"></l-control-layers>
              <l-tile-layer
                  key="01"
                  name="Default Base"
                  :url="url"
                  visiblity="False"
              />

              <l-layer-group>
                <l-layer-group v-for="(curr_etab, index ) in this.groupetable" :key=curr_etab.key  layer-type="overlay" :name=curr_etab.name visibility="true">
                  <l-marker v-for="(jpolistongoing, index) in get_Data(curr_etab.key)"
                            @click="markerWasClicked(sethiddenpopup(jpolistongoing))"
                            :key="index"
                            :visible="true"
                            :lat-lng="[jpolistongoing.latitude_y, jpolistongoing.longitude_x]"
                            :icon="geticon(jpolistongoing.type_detablissement)">
                    <l-popup> {{ getpopup(jpolistongoing) }}</l-popup>
                  </l-marker>
                </l-layer-group>
              </l-layer-group>

            </l-map>
          </div>
        </div>
        <!-- /.col6 -->
        <div v-if="Object.keys(schoolinfo).length > 0" class="col-md-5 brew-list" style="height: 500px">
          <div class="card-header">
            <h3 class="text-primary text-capitalize text-justify">{{schoolinfo.nom}}</h3>
          
          </div>
          <div class="card-body">
            <p class="text-capitalize text-justify"> {{schoolinfo.commune}}, {{schoolinfo.statut}}</p>
             <p class="text-capitalize text-justify"> {{schoolinfo.journees_portes_ouvertes}} </p>
             <a target="_blank" :href="'http://' + schoolinfo.url_et_id_onisep" class="btn btn-primary mt-5">Plus d'information</a>
          </div>
         
        </div>
        <!-- /.col6 -->
      </div>
      <!-- /.row -->
    </div>
  </div>

</template>





<script>
import { LMap, LTileLayer, LControlLayers, LMarker, LLayerGroup, LPopup } from "vue2-leaflet";
import "leaflet/dist/leaflet.css";

import axios from "axios";

var markerlycee = L.icon({
  iconUrl: "/themes/template/img/map/marker-icon-red.png",
  iconSize: [20, 30],
  iconAnchor: [10, 30],
  popupAnchor: [0, -30],
});

var markercollege = L.icon({
  iconUrl: "/themes/template/img/map/marker-icon-orange.png",
  iconSize: [20, 30],
  iconAnchor: [10, 30],
  popupAnchor: [0, -30],
});
var markeruniversite = L.icon({
  iconUrl: "/themes/template/img/map/marker-icon-yellow.png",
  iconSize: [20, 30],
  iconAnchor: [10, 30],
  popupAnchor: [0, -30],
});
var markercfa = L.icon({
  iconUrl: "/themes/template/img/map/marker-icon-violet.png",
  iconSize: [20, 30],
  iconAnchor: [10, 30],
  popupAnchor: [0, -30],
});

var markercommerce = L.icon({
  iconUrl: "/themes/template/img/map/marker-icon-gold.png",
  iconSize: [20, 30],
  iconAnchor: [10, 30],
  popupAnchor: [0, -30],
});
var markeriut = L.icon({
  iconUrl: "/themes/template/img/map/marker-icon-orange.png",
  iconSize: [20, 30],
  iconAnchor: [10, 30],
  popupAnchor: [0, -30],
});
var markeringenieur = L.icon({
  iconUrl: "/themes/template/img/map/marker-icon-green.png",
  iconSize: [20, 30],
  iconAnchor: [10, 30],
  popupAnchor: [0, -30],
});
var markermfr = L.icon({
  iconUrl: "/themes/template/img/map/marker-icon-blue.png",
  iconSize: [20, 30],
  iconAnchor: [10, 30],
  popupAnchor: [0, -30],
});
var markerdefault = L.icon({
  iconUrl: "/themes/template/img/map/marker-icon-black.png",
  iconSize: [20, 30],
  iconAnchor: [10, 30],
  popupAnchor: [0, -30],
});

export default {
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    LControlLayers,
    LLayerGroup,
  },
  data() {
    return {
      jpolist: [],
      jpolistuniv: [],
      jpolistlycee: [],
      jpolistcfa: [],
      jpolistingenieur: [],
      jpolistcommerce: [],
      jpolistiut: [],
      jpolistmfr: [],
      jpolistautreetab: [],
      url2: "http://{s}.tile.osm.org/{z}/{x}/{y}.png",
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      zoom: 6,
      center: [48.856614,2.3522219],
      schoolinfo: Object,

      overlay_lycee :"<img src='/themes/template/img/map/marker-icon-red.png' width='15' height='18'/> Lycée",
      overlay_univ : "<img src='/themes/template/img/map/marker-icon-yellow.png' width='15' height='18'/> Université",
      overlay_cfa : "<img src='/themes/template/img/map/marker-icon-violet.png' width='15' height='18'/> Cfa",
      overlay_ingenieur : "<img src='/themes/template/img/map/marker-icon-green.png' width='15' height='18'/> Ingenieur",
      overlay_commerce : "<img src='/themes/template/img/map/marker-icon-gold.png' width='15' height='18'/> Commerce",
      overlay_iut : "<img src='/themes/template/img/map/marker-icon-orange.png' width='15' height='18'/> Iut",
      overlay_mfr : "<img src='/themes/template/img/map/marker-icon-blue.png' width='15' height='18'/> Mfr",
      overlay_autresetab : "<img src='/themes/template/img/map/marker-icon-black.png' width='15' height='18'/> Autres",

      selected: "---liste des academies---",
      academies: [
        { value: "48.117266,-1.6777926", text: "rennes" },
        { value: "50.62925,3.057256", text: "lille" },
        { value: "49.894067,2.295753", text: "amiens" },
        { value: "48.879870,0.171253", text: "normandie" },
        { value: "47.218371,-1.553621", text: "nantes" },
        { value: "48.692054,6.184417", text: "nancy" },
        { value: "47.902964,1.909251", text: "orleans" },
        { value: "49.258329,4.031696", text: "reims" },
        { value: "48.5734053,7.7521113", text: "strasbourg" },
        { value: "48.856614,2.3522219", text: "idf" },
        { value: "47.322047,5.04148", text: "dijon" },
        { value: "47.237829,6.0240539", text: "besancon" },
        { value: "46.580224,0.340375", text: "poitiers" },
        { value: "45.833619,1.261105", text: "limoges" },
        { value: "45.764043,4.835659", text: "lyon" },
        { value: "45.777222,3.087025", text: "clermont-ferrand" },
        { value: "45.188529,5.724524", text: "grenoble" },
        { value: "44.837789,-0.57918", text: "bordeaux" },
        { value: "43.604652,1.444209", text: "toulouse" },
        { value: "43.529742,5.447427", text: "aix" },
        { value: "43.7101728,7.2619532", text: "nice" },
        { value: "42.039604,9.012893", text: "corse" },
        { value: "43.610769,3.876716", text: "montpellier" },
        { value: "16.265,-61.551", text: "guadeloupe" },
        { value: "14.6336817 ,-61.0198104", text: "martinique" },
        { value: "3.933889,-53.125782", text: "guyane" },
        { value: "-21.115141,55.536384", text: "reunion" },

      ],
      groupetable: [],
    };
  },
  methods: {
    handleMapClick(event) {
    },
    onChange:function(event){
      // console.log(event.target.value);
      this.center=(event.target.value).split(',');
      this.zoom = 10;
    },
    centerUpdated(center) {
      this.center = center;
    },
    zoomUpdated(zoom) {
      this.zoom = zoom;
    },


    geticon(type_detablissement) {
      if (type_detablissement.toLowerCase().indexOf("lycée")>-1 ) return markerlycee;
      else if (type_detablissement.indexOf("Centre de formation d'apprentis")>-1) return markercfa;
      else if (type_detablissement.toLowerCase().indexOf("université")>-1) return markeruniversite;
      else if (type_detablissement.indexOf("école de commerce")>-1) return markercommerce;
      else if (type_detablissement.indexOf("Ecole d'ingénieurs")>-1) return markeringenieur;
      else if (type_detablissement.indexOf("Institut universitaire de technologie")>-1) return markeriut;
      else if (type_detablissement.indexOf("Maison familiale rurale")>-1) return markermfr;
      else return markerdefault;
    },
    markerWasClicked(schoolClicked){
      this.schoolinfo = schoolClicked;
    },
    getpopup(jpo) {
      return (
          jpo.nom +
          "  " +
          jpo.journees_portes_ouvertes )
          ;
    },
    sethiddenpopup(jpo) {
      return (
          jpo
      );
    },
    set_Data: function() {
      this.groupetable= [
        { key: "lycee", name: this.overlay_lycee },
        { key: "univ", name: this.overlay_univ},
        { key: "Cfa", name: this.overlay_cfa},
        { key: "Ingenieur", name: this.overlay_ingenieur},
        { key: "Commerce", name: this.overlay_commerce},
        { key: "Iut", name: this.overlay_iut},
        { key: "Mfr", name: this.overlay_mfr},
        { key: "Autres", name: this.overlay_autresetab },
      ];

    },
    get_Data: function(type){
      if(type==="lycee")
        return this.jpolistlycee;
      else if(type ==="univ")
        return this.jpolistuniv;
      else if(type === "Cfa")
        return this.jpolistcfa;
      else if(type === "Ingenieur")
        return this.jpolistingenieur;
      else if(type === "Commerce")
        return this.jpolistcommerce;
      else if(type ==="Iut")
        return this.jpolistiut;
      else if (type === "Mfr")
        return this.jpolistmfr;
      else if( type === "Autres")
        return this.jpolistautreetab;
    },
  },
  mounted: function () {

    axios
        .get(
            "/modules/dlnkjpos/files/5fa586da5c4b6.json"
        )
        .then((r) => {
          var rdata=r.data;
          this.jpolist = r.data;

          var jsonString = JSON.stringify(this.jpolist);
          jsonString = jsonString.replace(/[\u007F-\uFFFF]/g, function(chr) {
            return "\\u" + ("0000" + chr.charCodeAt(0).toString(16)).substr(-4)
          })

          var jsontodata = JSON.parse(jsonString);
          // get list of JPO only
          jsontodata = jsontodata.filter(d => d.journees_portes_ouvertes !== "");



          this.jpolistuniv = jsontodata.filter(d => d.type_detablissement.toLowerCase().indexOf("université") > -1 );
          this.jpolistlycee = jsontodata.filter(d => d.type_detablissement.toLowerCase().indexOf("lycée") > -1);
          this.jpolistcfa = jsontodata.filter(d => d.type_detablissement.indexOf("Centre de formation d'apprentis") >-1);
          this.jpolistcommerce = jsontodata.filter(d => d.type_detablissement.indexOf("école de commerce") >-1 );
          this.jpolistingenieur = jsontodata.filter(d => d.type_detablissement.indexOf("Ecole d'ingénieurs")>-1);
          this.jpolistiut = jsontodata.filter(d => d.type_detablissement.indexOf("Institut universitaire de technologie") >-1);
          this.jpolistmfr = jsontodata.filter(d => d.type_detablissement.indexOf("Maison familiale rurale") >-1);
          this.jpolistautreetab = jsontodata.filter(d =>
              d.type_detablissement.toLowerCase().indexOf("université") == -1 &&
              d.type_detablissement.toLowerCase().indexOf("lycée") == -1 &&
              d.type_detablissement.indexOf("Centre de formation d'apprentis") ==-1 &&
              d.type_detablissement.indexOf("école de commerce") == -1 &&
              d.type_detablissement.indexOf("Ecole d'ingénieurs") == -1 &&
              d.type_detablissement.indexOf("Institut universitaire de technologie") == -1 &&
              d.type_detablissement.indexOf("Maison familiale rurale") == -1)
        });
    this.set_Data();
  },
}

</script>

<style lang="scss" scoped>
.brew-list {
  overflow: scrool;
  height: 96vh;
  li {
    &:hover {
      background-color: darkgrey;
    }
  }
}
</style>
